import axios from 'axios';
import apiConfig from '../../api.config';

export default function createPoliceS3User(body) {
  const {
    host,
    URIs: { policeReportCreateS3User },
  } = apiConfig;

  const uri = `${host}${policeReportCreateS3User}`;

  return axios.post(uri, body).then(res => {
    return res.data;
  });
}
